<template>
  <div id="brokerage" class="header-gap bo">
    <div class="sub-banner">
      <div class="container">
        <h1 v-html="$t('brokerage.banner-title')"></h1>
        <p v-html="$t('brokerage.banner-desc')"></p>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="column">
          <h2>{{$t("brokerage.doo-clearing")}}</h2>
          <p><i></i> {{$t("brokerage.doo-clearing-desc")}}</p>
          <a :href="dcUrl" target="_blank" v-t="'business-overview.learn-more'"></a>
        </div>
        <div>
          <img src="https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/doo/business_overview/brokerage_image1.png" />
        </div>
      </div>
      <div class="row">
        <div class="column">
          <h2>{{$t("brokerage.doo-financial")}}</h2>
          <p><i></i> {{$t("brokerage.doo-financial-desc")}}</p>
          <a href="https://www.doofinancial.com/" target="_blank" v-t="'business-overview.learn-more'"></a>
        </div>
        <div>
          <img src="https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/doo/business_overview/brokerage_image2.png" />
        </div>
      </div>
      <!-- <div class="row">
        <div class="column">
          <h2>{{$t("brokerage.doo-prime")}}</h2>
          <p><i></i> {{$t("brokerage.doo-prime-desc")}}</p>
          <a href="https://www.dooprime.com/" target="_blank" v-t="'business-overview.learn-more'"></a>
        </div>
        <div>
          <img src="https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/doo/business_overview/brokerage_image3.png"/>
        </div>
      </div> -->
    </div>
    <BOContactUs bocontent="brokerage"/>
  </div>
  <Modals />
</template>
  
<script setup>
  import "../less/style.css"
  import Modals from '@/components/Modals/ModalMain.vue'
  import BOContactUs from '@/components/BOContactUs.vue'

  import { useHead } from '@unhead/vue'
  import { useI18n } from 'vue-i18n'
  import { computed, onMounted } from 'vue'
  import { decodeHtml } from '@/utils'

  const { t, locale } = useI18n()

  const dcUrl = computed(() => {
    if (locale.value === 'sc' || locale.value === 'tc') {
      return 'https://sc.doofinancial.com/cn';
    }
    return 'https://sc.doofinancial.com/en';
  })

  useHead({
    title: computed(() => decodeHtml(t('seo.brokerage.title'))),
    meta: [
      { name: 'description', content: computed(() => t('seo.brokerage.description')) },
      { name: 'keywords', content: computed(() => t('seo.brokerage.keywords')) },
    ],
  })

  onMounted(() => {
    if (typeof document !== 'undefined')
      document.dispatchEvent(new Event('prerender-ready'))
  })

</script>

<style lang="less">
  @import '../less/mediaQuery.less';

  #brokerage {
    .sub-banner {
      background:url('https://cdn.dootech.io/doo/business_overview/banner_brokerage-new.png') no-repeat center top;
      @media @mobile-screen {
        background:url('https://cdn.dootech.io/doo/business_overview/banner_brokerage_mobile-new.png') no-repeat center top;
      }
      .container {
        @media only screen and (max-width:1500px) and (min-width:835px) {
          max-width: 40%;
          margin: 0;
        }
      }
    }
    @media only screen and (max-width:1400px) and (min-width:951px) {
      .container {
        padding:0 32px;
      }
    }
    
  }
</style>
